// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3nLj1","checkboxCol":"Table_checkboxCol__3LpDv","emailCol":"Table_emailCol__1g730","actionCol":"Table_actionCol__37l6R"};